import { Title } from '@angular/platform-browser'
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { trigger, state, style } from '@angular/animations'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { MenuService } from '@services/menu/menu.service'
import { AuthManagerService } from '@services/auth/auth-manager.service'
import { MessagesService } from '@services/messages/message.service'
import { TranslatorService } from '@services/translator/translator.service'
import { environment } from '@env/environment'
import { authService } from '@app/core/services-api/auth.service'
import { MsalService } from '@azure/msal-angular'
import { SessionService } from '@app/custom-shared/services/session-service/session.service'
import { TranslateService } from '@ngx-translate/core'
import { MessageService } from 'primeng/api'
import { apiConfig } from '@app/app-config'
import { CookieService } from 'ngx-cookie-service'

/**
 * The home page that displays the main structure of your desktop & mobile application once the user is logged in like the `Main menu`, `header`, `main body` and `footer`.
 *
 * It is not recommended to modify this component, but if you will need to customize it in order to integrate your UI Design, it is recommended
 * that you skip the generation of this file via `cli-config.json` file and you will have to maintain it:
 * https://wiki.vermeg.com/display/PFD/Workspace+Properties#WorkspaceProperties-F3
 */
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  animations: [
    trigger('workspace-animation', [
      state(
        'collapsed',
        style({
          transform: 'translateY(0px) perspective(10px) rotateX(1deg)',
        })
      ),
      state(
        'expanded',
        style({
          transform: 'translateY(-120px) perspective(10px) rotateX(1deg)',
        })
      ),
    ]),
  ],
})
export class MainComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * The base path of your REST API calls
   */
  BASE_PATH = environment.basePath
  /**
   * The current workspace identifier
   */
  workSpaceId = 0
  /**
   * Option to open the workspace panel which is `false` by default
   */
  openWorspaceBar = false
  /**
   * Option to collapse or expand the main menu's panel
   */
  expandedState = 'collapsed'
  /**
   * The menu items constant used to translate your menu
   */
  MENU_ITEMS = 'Menu Items.'
  /**
   * The Subjet emitter object to destroy all the subscriptions
   * when the component is destroyed
   */
  destroy$: Subject<boolean> = new Subject<boolean>()
  /**
   * The title of the current opened page
   */
  screenTitle = ''
  /**
   * Option to expand or collapse the main menu's panel
   */
  menuExpanded = false
  /**
   * The current styleName of the current page
   */
  styleClass
  // palmyra-needle-add-menu-entry: Do not delete this line
  menu = [
    {
      label: 'Dashboard',
      roles: ['Acessar dashboard', 'admin'],
      id: 'dashboard',
      link: ['/dashboard'],
      command: event => this.openPage(event.item),
    },
    {
      label: 'Active',
      roles: [
        'Ativos - Relatórios',
        'Ativos - Operações',
        'Ativos - Contratos e Documentos',
        'Ativos - Ajuda',
        'admin',
      ],
      id: 'active',
      items: [
        {
          label: 'Operations',
          roles: ['Ativos - Operações', 'admin'],
          id: 'operations',
          items: [
            {
              label: 'File Upload',
              roles: ['Operações - Upload de Boleta', 'admin'],
              id: 'file-upload',
              link: ['/load_files/Parent_Upload'],
              command: event => this.openPage(event.item),
            },
            // {
            //   label: 'Palmyra Upload Configuration',
            //   roles: ['Operações - Upload de Boleta', 'admin'],
            //   id: 'palmyra-upload-configuration',
            //   link: ['/load_files/upload-alt'],
            //   command: (event) => this.openPage(event.item),
            // },
            // {
            //   label: 'Ticket',
            //   roles: ['Operações - Lay-outs SC', 'admin'],
            //   id: 'ticket',
            //   link: [],
            //   command: (event) => this.openPage(event.item),
            // },
            {
              label: 'Manual Billing',
              roles: ['Operações - Boletagem Manual', 'admin'],
              id: 'manual-billing',
              items: [
                {
                  label: 'Equities _ Term Operations',
                  roles: ['Boletagem Manual - Termo de ações', 'admin'],
                  id: 'boletagem-manual-bloqueio-desbloqueio-de-fundos',
                  link: ['/settlement_instruction/parent_forward_instruction'],
                  command: event => this.openPage(event.item),
                },
                // {
                //   label:
                //     'Equities _ Anticipated Term Operations',
                //   roles: [
                //     'Boletagem Manual - Bloqueio/desbloqueio de Renda Fixa',
                //     'Operações - Boletagem Manual',
                //     'admin',
                //   ],
                //   id: 'boletagem-manual-bloqueio-desbloqueio-de-renda-fixa',
                //   link: [],
                //   command: (event) => this.openPage(event.item),
                // },
                {
                  label: 'Subscription/ Redemption',
                  roles: ['Boletagem Manual - Ingresso/Retirada', 'admin'],
                  id: 'boletagem-manual-bloqueio-desbloqueio-de-renda-variavel',
                  link: ['/paymentOrder/parent-cash-deposit-withdrawal'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'SWAP',
                  roles: ['Boletagem Manual - Swap', 'admin'],
                  id: 'swap',
                  link: ['/swapOperation/parent-swap'],
                  command: event => this.openPage(event.item),
                },
                // {
                //   label: 'Anticipated SWAP',
                //   roles: [
                //     'Boletagem Manual - Cadastro de Opções Flexíveis',
                //     'Operações - Boletagem Manual',
                //     'admin',
                //   ],
                //   id: 'boletagem-manual-cadastro-de-opcoes-flexiveis',
                //   link: [],
                //   command: (event) => this.openPage(event.item),
                // },
                {
                  label: 'Forex',
                  roles: ['Boletagem Manual - Câmbio', 'admin'],
                  id: 'boletagem-manual-compromissadas',
                  link: ['/paymentOrder/parent-cash-fx-change'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Variable Incomes',
                  roles: ['Boletagem Manual - Renda variável', 'admin'],
                  id: 'boletagem-manual-despesas-receitas',
                  link: ['/variableincome/Parent_VariableIncome'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Fixed Incomes',
                  roles: ['Boletagem Manual - Renda Fixa', 'admin'],
                  id: 'boletagem-manual-emprestimos-de-acoes',
                  link: ['/settlement_instruction/parent_fixed-income'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Futures',
                  roles: ['Boletagem Manual - Futuros', 'admin'],
                  id: 'boletagem-manual-exercicio-de-opcoes-de-futuros',
                  link: ['/settlement_instruction/parent_future'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Fund Units',
                  roles: ['Boletagem Manual - Cotas de Fundos', 'admin'],
                  id: 'boletagem-manual-exercicio-de-opcoes-de-futuros',
                  link: ['/settlement_instruction/parent_instruction-unit'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Block /Unblock of Funds Units',
                  roles: [
                    'Boletagem Manual - Bloqueio/desbloqueio de Fundos',
                    'admin',
                  ],
                  id: 'boletagem-manual-exercicio-de-opcoes-de-renda-variavel',
                  link: [
                    '/settlement_instruction/parent_block-unblock-instruction-unit',
                  ],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Block /Unblock of Variable Incomes',
                  roles: [
                    'Boletagem Manual - Bloqueio/desbloqueio de Renda variável',
                    'admin',
                  ],
                  id: 'boletagem-manual-fundos-de-investimentos',
                  link: ['/settlement_instruction/parent_block-unblock-rv'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Block /Unblock of Fixed Incomes',
                  roles: [
                    'Boletagem Manual - Bloqueio/desbloqueio de Renda Fixa',
                    'admin',
                  ],
                  id: 'boletagem-manual-futuros',
                  link: ['/settlement_instruction/parent_block-unblock-rf'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Repo',
                  roles: ['Boletagem Manual - Compromissadas', 'admin'],
                  id: 'boletagem-manual-ingresso-retirada',
                  link: ['/settlement_instruction/parent_repo'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'RepoSam',
                  roles: ['Boletagem Manual - Compromissadas SAM', 'admin'],
                  id: 'boletagem-manual-ingresso-retirada1',
                  link: ['/settlement_instruction/parent_repo_sam'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Exercice of options (on Futures)',
                  roles: [
                    'Boletagem Manual - Exercício de opções de futuros',
                    'admin',
                  ],
                  id: 'boletagem-manual-livre-digitacao',
                  link: ['/optionExercice/view-ParentOptionExerciceFutur'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Exercice of options (on Variable Incomes)',
                  roles: [
                    'Boletagem Manual - Exercício de opções de Renda variável',
                    'admin',
                  ],
                  id: 'fixed-income',
                  link: ['/optionExercice/view-ParentOptionExerciceRV'],
                  command: event => this.openPage(event.item),
                },
                {
                  label: 'Stock Loan',
                  roles: ['Boletagem Manual - Empréstimos de ações', 'admin'],
                  id: 'stock-lending',
                  link: ['/paymentOrder/parent-stock-lending-instruction'],
                  command: event => this.openPage(event.item),
                },
                // {
                //   label: 'Stock Loan Anticipation',
                //   roles: [
                //     'Boletagem Manual - Swap',
                //     'Operações - Boletagem Manual',
                //     'admin',
                //   ],
                //   id: 'boletagem-manual-swap',
                //   link: [],
                //   command: (event) => this.openPage(event.item),
                // },
                // {
                //   label: 'Stock Loan Renewal ',
                //   roles: [
                //     'Boletagem Manual - Termo de ações',
                //     'Operações - Boletagem Manual',
                //     'admin',
                //   ],
                //   id: 'boletagem-manual-termo-de-acoes',
                //   link: [],
                //   command: (event) => this.openPage(event.item),
                // },
                {
                  label: 'Cash In/Out',
                  roles: ['Boletagem Manual - Despesas/receitas', 'admin'],
                  id: 'revenues-expenses-trades',
                  link: ['/paymentOrder/parent-revenue-expenses-trades'],
                  command: event => this.openPage(event.item),
                },
                // {
                //   label: 'Flexible Options',
                //   roles: [
                //     'Boletagem Manual - Termo de ações',
                //     'Operações - Boletagem Manual',
                //     'admin',
                //   ],
                //   id: 'boletagem-manual-termo-de-acoes',
                //   link: [],
                //   command: (event) => this.openPage(event.item),
                // },
                // {
                //   label: 'Free Of Payment',
                //   roles: [
                //     'Boletagem Manual - Termo de ações',
                //     'Operações - Boletagem Manual',
                //     'admin',
                //   ],
                //   id: 'boletagem-manual-termo-de-acoes',
                //   link: [],
                //   command: (event) => this.openPage(event.item),
                // },
              ],
            },
            {
              label: 'Layouts SC',
              roles: ['Operações - Lay-outs SC', 'admin'],
              id: 'layouts-sc',
              link: [],
              command: event => this.openPage(event.item),
            },
            // {
            //   label: 'Reported Operations',
            //   roles: ['XML Anbima'],
            //   id: 'new-reports-type',
            //   link: ['/new-reports-type'],
            //   command: event => this.openPage(event.item),
            // },
            // {
            //label: 'Operations',
            //roles: ['Operações - Boletas', 'admin'],
            //id: 'ticket',
            //link: [],
            //command: (event) => this.openPage(event.item),
            //},

            {
              label: 'anbima XML',
              roles: ['Operações - Boletagem Manual', 'admin'],
              id: 'anbima-xml',
              link: ['/active/reports/anbima-xml'],
              command: event => this.openPage(event.item),
            },
            {
              label: 'Reports',
              roles: ['Operações - Boletagem Manual', 'admin'],
              id: 'reportss',
              link: ['/active/reports/reports'],
              command: event => this.openPage(event.item),
            },
          ],
        },
        {
          label: 'Reports',
          roles: ['Ativos / Relatórios' ],
          id: 'reports',
          items: [
            {
              label: 'Qliksense',
              roles: ['Qliksense'],
              id: 'qliksense',
              link: ['/variableincome/qlik-view'],
              command: event => this.openPage(event.item),
            },
            {
              label: 'Anbima XML',
              roles: ['XML Anbima'],
              id: 'anbima-xml',
              link: ['/active-report/reports/anbima-xml'],
              command: event => this.openPage(event.item),
            },
            //IS IS IMPORTANT TO WORK !!!!!!
            {
              label: 'Reported Operations',
              roles: ['Reported_Operations'],
              id: 'new-reports-type',
              link: ['/active-report/reports/new-reports-type'],
              command: event => this.openPage(event.item),
            },
            {
              label: 'Consult Requests',
              roles: ['Consult_Requests'],
              id: 'consult-requests',
              link: ['/active-report/reports/consult-requests'],
              command: event => this.openPage(event.item),
            },
            {
              label: 'Reports',
              roles: ['Relatórios'],
              id: 'reports',
              link: ['/active-report/reports/reports'],
              command: event => this.openPage(event.item),
            },
            {
              label: 'Portfolio group',
              roles: ['Grupo de Carteiras'],
              id: 'reports-ptf-group',
              link: ['/active-report/reports/reports-ptf-group'],
              command: event => this.openPage(event.item),
            },
            {
              label: 'Scheduling',
              roles: ['Agendamento de relatórios'],
              id: 'reports-scheduling',
              link: ['/active-report/reports/reports-scheduling'],
              command: event => this.openPage(event.item),
            },
          ],
        },
        {
          label: 'Contracts and documents',
          roles: ['Ativos - Contratos e Documentos', 'admin'],
          id: 'contracts-and-documents',
          link: [],
          command: event => this.openPage(event.item),
        },
        {
          label: 'Help',
          roles: ['Ativos - Ajuda', 'admin'],
          id: 'help',
          link: [],
          command: event => this.openPage(event.item),
        },
      ],
    },
  ]

  // end palmyra-needle-add-menu-entry
  constructor(
    private menuService: MenuService,
    private authServicee: MsalService,
    private translatorService: TranslatorService,
    private sessionService: SessionService,
    private router: Router,
    private titleService: Title,
    private cookieService:CookieService
  ) {}

  /**
   * Initializes the min component
   * @returns {void}
   */
  ngOnInit() {
    this.translatorService.translateMenuItem(this.menu)
    this.menu = this.menuService.filterByRole(this.menu)
    this.getScreenTitle(this.menu)
    this.menuExpanded = this.menuService.getMenuInitialState()
  }

  /***
   * Adds styleName to html root element
   */
  ngAfterViewInit() {
    ;(document.querySelector('html') as HTMLElement).className = 'home'
  }
  /**
   * Uses the keyboard enter button like mouse Click
   * @param event
   */
  keyboardEnter(event: any) {
    event.srcElement.click()
  }
  /**
   * set focus to the first element
   *  @param element
   *  @returns {void}
   */
  focus(element): void {
    element.querySelectorAll('[tabindex]')[0].focus()
  }
  /**
   * Logout the logged user
   */

  /**
   * Open the page in a workspace and close the main menu's sidebar
   */
  openPage(menu: any) {
    this.open(menu)
    this.screenTitle = menu.label
    this.styleClass = menu.styleClass
  }
  /**
   * Set the screen title based on menu items
   * @param menu
   */
  getScreenTitle(menu: any) {
    menu.map(item => {
      if (item.items) {
        this.getScreenTitle(item.items)
      } else if (item && item.link == this.router.url) {
        this.screenTitle = item.label
      }
    })
  }

  /**
   * Open a page
   * @param menu
   */
  open(menu: any) {
    const link = menu.link ? menu.link[0] : undefined
    const externalLink = link ? link.startsWith('http') : link
    const sameNavigation = menu.label === this.titleService.getTitle()
    const queryParams = !sameNavigation
      ? menu.params
      : {
          ...menu.params,
          reload: window.crypto.getRandomValues(new Uint16Array(1))[0],
        }
    externalLink
      ? window.open(link, menu.openWindow ? '_blank' : '_self')
      : this.router.navigate(menu.link, { queryParams })
    this.titleService.setTitle(menu.label)
  }
  /**
   * Toggles menu state
   */
  toggleMenu() {
    this.menuExpanded = !this.menuExpanded
    this.menuService.setMenuState(this.menuExpanded)
  }
  /**
   * Opens the multi-worksapce bar
   */
  displayMultiWorkspacesBar() {
    this.expandedState = this.openWorspaceBar ? 'collapsed' : 'expanded'
    this.openWorspaceBar = !this.openWorspaceBar
  }
  /**
   * Closes the multi-worksapce bar
   */
  closeWorkspaceBar() {
    this.expandedState = 'collapsed'
    this.openWorspaceBar = false
  }
  logout() {
    let loginDisplay = this.authServicee.instance.getAllAccounts()[0]
    this.sessionService.clearFirstTime()
    this.authServicee
      .acquireTokenSilent({
        account: loginDisplay,
        // redirectUri: environment.msalUrl,
        scopes: apiConfig.scopes,
      })
      .subscribe(authResult => {
        this.authServicee.logout()
      })
      .add(() => {
        sessionStorage.clear();
        localStorage.clear();
        this.cookieService.deleteAll('/', 'b2clogin.com');
      })
  }
  /**
   * Destroys the component and all the subscriptions
   */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
/**
 * The menu entry interface
 */
export interface Menu {
  /**
   * The menu entry's title
   */
  label: string
  /**
   * The menu entry's roles
   */
  roles?: string[]
  /**
   * The menu entry's styleName
   */
  styleName?: string
  /**
   * The menu entry's icon using primeicons or FontAwesome
   */
  icon?: string
  /**
   * The menu entry's children items
   */
  items?: Menu[]
  /**
   * The menu entry's link to open
   */
  link?: string[]
  /**
   * The menu entry's technical function to call onClick event
   */
  command?: any
}
